import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL + 'auth';

class AuthService {
    /**
     * Rejestruje nowego użytkownika, wysyłając dane do endpointu rejestracji.
     * 
     * @param {Object} user - Obiekt zawierający dane użytkownika (firstName, lastName, email, phone, password)
     * @returns {Promise<Object>} Zwraca dane odpowiedzi z serwera po pomyślnej rejestracji.
     * @throws Błąd, jeśli rejestracja nie powiedzie się.
     */
    async register(user) {
        try {
          const response = await axios.post(API_URL + '/register', {
            firstName: user.firstName,
            lastName: user.lastName,
            phone: user.phone,
            password: user.password
          });
          return response.data;
        } catch (error) {
          console.error("Błąd podczas rejestracji:", error);
          throw error;
        }
    }
    
    /**
     * Loguje użytkownika, wysyłając dane logowania (email, password) do serwera.
     * 
     * @param {Object} user - Obiekt zawierający dane logowania użytkownika (email, password)
     * @returns {Promise<Object>} Zwraca dane odpowiedzi z serwera po pomyślnym logowaniu.
     * @throws Błąd, jeśli logowanie nie powiedzie się.
     */
    async login(user) {
        try {
          const response = await axios.post(API_URL + '/login', {
            username: user.username,
            password: user.password
          });
          return response.data;
        } catch (error) {
          console.error("Błąd podczas logowania:", error);
          throw error;
        }
    }

    /**
     * Wylogowuje użytkownika, wysyłając żądanie do serwera.
     * Żądanie wylogowania zawiera nagłówek Authorization z tokenem JWT.
     * 
     * @returns {Promise<void>} Zwraca obietnicę, która kończy się, gdy użytkownik zostanie wylogowany.
     * @throws Błąd, jeśli operacja wylogowania nie powiedzie się.
     */
    async logout() {
        try {
            await axios.post(API_URL + '/logout', {}, {
            withCredentials: true,
            headers: {
                Authorization: `Bearer`
            }
            });
        } catch (error) {
            console.error('Błąd podczas wylogowania:', error);
        }
    }

    /**
     * Weryfikuje kod 2FA wprowadzony przez użytkownika.
     *
     * @param {Object} data - Obiekt zawierający dane do weryfikacji 2FA.
     * @param {string} data.email - Adres e-mail użytkownika.
     * @param {string} data.twoFactorCode - Kod weryfikacyjny 2FA wprowadzony przez użytkownika.
     * @return {Promise<Object>} - Zwraca obiekt z odpowiedzią serwera w przypadku sukcesu.
     * @throws {Object} - Zwraca błąd w przypadku niepowodzenia.
     */
    verify2fa(data) {
      return axios.post(`${API_URL}/verify-2fa`, data)
        .then(response => response.data)
        .catch(error => {
          throw error.response.data;
        });
    }
}

export default new AuthService();
